import React from "react";
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from "@mui/material";
import WorkspacesRoundedIcon from "@mui/icons-material/WorkspacesRounded";

export const panelSx = {
  borderRadius: 3,
  // border: "1px solid rgba(148,163,184,0.22)",  
  background: "#FFFFFF",
  boxShadow: "0 10px 24px rgba(15,23,42,0.045)",
};

export const metricTileSx = {
  p: 1.5,
  borderRadius: 2.5,
  backgroundColor: "#F8FAFC",
  border: "1px solid rgba(226,232,240,0.95)",
};

export const actionButtonSx = {
  px: 2.2,
                      py: 1.1,
                      borderRadius: 999,
                      textTransform: "none",
                      fontWeight: 700,
                       whiteSpace: "nowrap",
                      color: "#082F49",
                      background: "linear-gradient(135deg, #FDE68A, #F59E0B)",
                      boxShadow: "0 16px 30px rgba(245, 158, 11, 0.28)",
};

const STATUS_TONES = {
  ACTIVE: { bg: "rgba(22,163,74,0.14)", color: "#166534", border: "rgba(22,163,74,0.18)" },
  INACTIVE: { bg: "rgba(100,116,139,0.12)", color: "#475569", border: "rgba(100,116,139,0.18)" },
  PLANNED: { bg: "rgba(59,130,246,0.14)", color: "#1D4ED8", border: "rgba(37,99,235,0.18)" },
  IN_PROGRESS: { bg: "rgba(245,158,11,0.16)", color: "#92400E", border: "rgba(217,119,6,0.18)" },
  READY: { bg: "rgba(59,130,246,0.14)", color: "#1D4ED8", border: "rgba(37,99,235,0.18)" },
  LIVE: { bg: "rgba(20,184,166,0.14)", color: "#0F766E", border: "rgba(13,148,136,0.18)" },
  ON_HOLD: { bg: "rgba(236,72,153,0.14)", color: "#9D174D", border: "rgba(190,24,93,0.18)" },
  BLOCKED: { bg: "rgba(239,68,68,0.14)", color: "#B91C1C", border: "rgba(220,38,38,0.18)" },
  COMPLETED: { bg: "rgba(14,165,233,0.14)", color: "#0369A1", border: "rgba(2,132,199,0.18)" },
  CANCELLED: { bg: "rgba(100,116,139,0.12)", color: "#334155", border: "rgba(100,116,139,0.18)" },
};

export function statusChip(status) {
  const normalized = String(status || "UNKNOWN").toUpperCase();
  const tone = STATUS_TONES[normalized] || {
    bg: "rgba(100,116,139,0.12)",
    color: "#334155",
    border: "rgba(100,116,139,0.18)",
  };
  return (
    <Chip
      size="small"
      label={normalized.replace(/_/g, " ")}
      sx={{
        backgroundColor: tone.bg,
        color: tone.color,
        border: `1px solid ${tone.border}`,
        fontWeight: 800,
        letterSpacing: "0.03em",
        textTransform: "uppercase",
        borderRadius: 2.5,
      }}
    />
  );
}

export function PageShell({ title, subtitle, actions, children,leadingAction }) {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 3 },
        pt: { xs: 2, md: 2 },
        minHeight: "100%",
        background: "linear-gradient(180deg, #F3F6FA 0%, #EDF2F7 100%)",
      }}
    >
      <Card
        elevation={0}
        sx={{
          mb: 3,
          borderRadius: 4,
          overflow: "hidden",
          border: "1px solid rgba(15,23,42,0.08)",
          background:"linear-gradient(135deg, rgba(15, 23, 42, 0.96), rgba(15, 118, 110, 0.88) 55%, rgba(8, 47, 73, 0.92))",
          color: "#fff",
          boxShadow: "0 28px 60px rgba(15,23,42,0.18)",
        }}
      >
        <CardContent sx={{ p: { xs: 2.25, md: 3 } }}>
          {leadingAction ? (   
            <Box sx={{ mb: 2.25 }}>
              {leadingAction}
            </Box>
          ) : null}
          <Stack direction={{ xs: "column", xl: "row" }} spacing={2.5} justifyContent="space-between" alignItems={{ xs: "flex-start", xl: "center" }}>
            <Box sx={{ maxWidth: 760 }}>
              {/* <Chip
                icon={<WorkspacesRoundedIcon fontSize="small" />}
                label="Projects Workspace"
                sx={{
                  mb: 1.5,
                  color: "#DBEAFE",
                  backgroundColor: "rgba(255,255,255,0.08)",
                  border: "1px solid rgba(255,255,255,0.12)",
                  fontWeight: 700,
                }}
              /> */}
              <Typography sx={{ color: "#F8FAFC", fontSize: { xs: 28, md: 40 }, fontWeight: 700, letterSpacing: "-0.05em", lineHeight: 1 }}>
                {title}
              </Typography>
              {subtitle ? (
                <Typography sx={{ mt: 1.2, color: "rgba(226,232,240,0.82)", fontSize: 15, lineHeight: 1.65, maxWidth: 720 }}>
                  {subtitle}
                </Typography>
              ) : null}
            </Box>
            {actions ? (
              <Box
                sx={{
                  // width: { xs: "100%", xl: "auto" },
                  // p: 1.25,
                  // borderRadius: 3,
                  // backgroundColor: "rgba(255,255,255,0.07)",
                  // border: "1px solid rgba(255,255,255,0.12)",
                  // alignSelf: { xs: "stretch", xl: "center" },
                  // "& .MuiButton-root": {
                  //   borderRadius: 3,
                  //   textTransform: "none",
                  //   fontWeight: 800,
                  // },
                }}
              >
                {actions}
              </Box>
            ) : null}
          </Stack>
        </CardContent>
      </Card>
      {children}
    </Box>
  );
}

export function SummaryCard({ title, value, subtitle }) {
  return (
    <Card elevation={0} sx={{ ...panelSx, height: "100%" }}>
      <CardContent sx={{ p: 2.5 }}>
        <Typography sx={{ fontSize:{xs:10,md:15}, fontWeight: 600, color: "#64748B", textTransform: "uppercase", letterSpacing: "0.08em" }}>
          Program Metric
        </Typography>
        <Typography sx={{ mt: 0.75, fontSize: 15, fontWeight: 700, color: "#0F172A" }}>
          {title}
        </Typography>
        <Typography sx={{ mt: 1.75, fontSize: { xs: 34, md: 40 }, fontWeight: 900, color: "#0F172A", letterSpacing: "-0.05em" }}>
          {value}
        </Typography>
        {subtitle ? (
          <Typography sx={{ mt: 1, fontSize: 13, lineHeight: 1.7, color: "#64748B" }}>
            {subtitle}
          </Typography>
        ) : null}
      </CardContent>
    </Card>
  );
}
